import { Component, Input, OnChanges } from '@angular/core';

import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-history',
	templateUrl: './history.component.html',
	styleUrls: ['./history.component.css'],
})
export class HistoryComponent implements OnChanges {
	@Input() type: string;
	@Input() id: string;

	data: Array<any> = [];
	tableRows: Array<any> = [
		{ id: 'updated', name: 'Zaktualizowano' },
		{ id: 'user', name: 'Użytkownik' },
		{ id: 'field', name: 'Pole' },
		{ id: 'oldValue', name: 'Stara wartość' },
		{ id: 'newValue', name: 'Nowa wartość' },
	];

	constructor(private readonly api: Data2Service) {}

	ngOnChanges(): void {
		if (!this.type || !this.id) {
			return;
		}
		this.api.post('/history/', { type: this.type, id: this.id }, (result, error) => {
			this.data = result.data;
		});
	}
}
